import { render } from "./Stand.vue?vue&type=template&id=1e885ed2&scoped=true"
import script from "./Stand.vue?vue&type=script&lang=js"
export * from "./Stand.vue?vue&type=script&lang=js"

import "./Stand.vue?vue&type=style&index=0&id=1e885ed2&lang=scss&scoped=true"

import exportComponent from "C:\\websites\\kroechkwis-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e885ed2"]])

export default __exports__